$(document).ready(function() {

	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	// brands

	$('.brands__slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		rtl: dirRtlFlag,
		autoplay: true,
		speed: 2000,
		autoplaySpeed: 0,
		pauseOnHover: false,
		pauseOnFocus: false,
		cssEase: 'linear',
		slidesToShow: 10,
		responsive: [{
				breakpoint: 1550,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 980,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
			{
				breakpoint: 490,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
		]
	});

	// brands inner 
	$('.brands2__slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		rtl: dirRtlFlag,
		autoplay: true,
		speed: 2000,
		autoplaySpeed: 0,
		pauseOnHover: false,
		pauseOnFocus: false,
		cssEase: 'linear',
		slidesToShow: 10,
		responsive: [{
				breakpoint: 1550,
				settings: {
					slidesToShow: 8,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 5,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 980,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
			{
				breakpoint: 490,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: false,
				}
			},
		]
	});


	// numbers animation

	if ($(window).width() >= 992) {
		$(".hp-brands").hover(
			function() {
				// $(".number-counter__num").scrollTop($(".number-counter__num").scrollTop() + 59);
				var elH = $('.number-counter').get(0).scrollHeight;
				var newelH = elH - 110;
				$(".number-counter").animate({
					scrollTop: newelH
				}, 3000);
			}
			// ,
			// function() {
			// 	$(".number-counter").animate({
			// 		scrollTop: 0
			// 	}, 3000);
			// },
		);
	} else {
		$(".hp-brands").waypoint(function() {
			var elH = $('.number-counter').get(0).scrollHeight;
			var newelH = elH - 110;
			$(".number-counter").animate({
				scrollTop: newelH
			}, 3000);

		}, {
			offset: '60%'
		});
	}


	$(".numbers").waypoint(function() {

		$({
			// blurRadius: 5
		}).animate({
			// blurRadius: 0
		}, {
			duration: 2000,
			easing: 'swing',
			step: function() {
				$(".number-box__num").css({
					// "-webkit-filter": "blur(" + this.blurRadius + "px)",
					// "filter": "blur(" + this.blurRadius + "px)"
				});
			}
		});
		var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(',');
		$(".number-box__num").each(function() {
			var tcount = $(this).data("count");
			$(this).animateNumber({
					number: tcount,
					easing: 'easeInQuad',
					"font-size": "72px",
					numberStep: comma_separator_number_step
				},
				2000);
		});
		this.destroy();

	}, {
		offset: '60%'
	}); 

	// text animation

	// const text = document.querySelector(".text-anim p");

	// text.innerHTML = text.innerText
	// 	.split("")
	// 	.map(
	// 		(char, i) => `<span style="transform:rotate(${i * 7.9}deg)">${char}</span>`
	// 	)
	// 	.join("");

	// const text2 = document.querySelector(".text-anim2 p");

	// text2.innerHTML = text2.innerText
	// 	.split("")
	// 	.map(
	// 		(char, i) => `<span style="transform:rotate(${i * 7.9}deg)">${char}</span>`
	// 	)
	// 	.join("");


});